interface DayTotal {
  date: string
  [key: string]: number | string
}

export function createBarChartSeries(
  specificDateTotals: DayTotal[] | undefined,
  type: keyof DayTotal,
  startDate?: Date,
  endDate?: Date
): { name: string; data: { x: string; y: number }[] }[] {
  let chartStartDate: Date
  let chartEndDate: Date

  if (startDate && endDate) {
    chartStartDate = new Date(startDate)
    chartEndDate = new Date(endDate)
  } else {
    chartEndDate = new Date()
    chartStartDate = new Date()
    chartStartDate.setDate(chartEndDate.getDate() - 29)
  }

  const totalsByDay =
    specificDateTotals?.reduce<Record<string, DayTotal>>((acc, cur) => {
      acc[new Date(cur.date).toISOString().split('T')[0]] = cur
      return acc
    }, {}) || {}

  const daysDiff =
    Math.ceil((chartEndDate.getTime() - chartStartDate.getTime()) / (1000 * 60 * 60 * 24)) + 1

  const data = Array.from({ length: daysDiff }, (_, i) => {
    const date = new Date(chartStartDate)
    date.setDate(chartStartDate.getDate() + i)
    const key = date.toISOString().split('T')[0]
    const y = Number(totalsByDay[key]?.[type] ?? 0)
    return { x: key, y }
  })

  return [
    {
      name: 'Chart Series',
      data,
    },
  ]
}
